<template>
    <div class="w-100 h-100 text-center">
        <br /><br />
            <h2 class="tw-mb-0 text-aegis-dk">
                AE/SAE Report Download
            </h2>
            <br />
            <b-button variant="success" @click="download_report"><i class="fa fa-download"></i> Download Report</b-button>
    </div>
</template>


<!-- New step!
     Add Multiselect CSS. Can be added as a static asset or inside a component. -->
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<script>

import { HTTP } from "@/utilities/http-common";
import DashboardBaseTemplate from "@/layouts/DashboardBaseTemplate.vue";
import HandleErrors from "@/utilities/handle-errors";

import * as _ from "lodash";

export default {
    mixins: [DashboardBaseTemplate],
    components: {},
    data: function () {
        return {
            download_link: process.env.VUE_APP_AXIOS_BASE_URL + '/kenya/ae-sae-reports/'+this.$route.params.reportID+'/'
        };
    },
    computed: {
    },
    watch: {
    },
    mounted: function () {
    },
    methods: {
        download_report: function(){
            HTTP.get(this.download_link, { responseType: "arraybuffer" })
                .then((response) => {
                    var fileURL = window.URL.createObjectURL(
                        new Blob([response.data])
                    );

                    var fileLink = document.createElement("a");
                    fileLink.href = fileURL;
                    fileLink.setAttribute("download", 'AE-SAE Report - '+this.$route.params.reportID+'.csv');
                    document.body.appendChild(fileLink);
                    fileLink.click();
                })
                .catch((error) => {
                    HandleErrors.HandleErrors(error);
                });
        }
    },
};
</script>

<style>
</style>